import { useVoiceAssistantStore } from 'state/voiceAssistantStore';

import VoiceAssistant from './VoiceAssistant/VoiceAssistant';

import S from './Footer.module.scss';

export interface FooterProps {
  className?: string;
}

const Footer = ({ ...rest }: FooterProps) => {
  const { isVoiceAssistantVisible } = useVoiceAssistantStore();

  return (
    <footer className={S.FooterWrapper} {...rest}>
      {isVoiceAssistantVisible && <VoiceAssistant />}
    </footer>
  );
};

export default Footer;
